import { lazy } from 'react';
import NotFound from '../pages/NotFound';
import TestimonialsPage from '../pages/testimonials/page';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const InsightDetailPage = lazy(() => import('../pages/insight-detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const DashboardLayout = lazy(() => import('../pages/dashboard/page'));
const DashboardOverview = lazy(() => import('../pages/dashboard/overview/page'));
const InvestmentPlan = lazy(() => import('../pages/dashboard/investment-plan/page'));
const Performance = lazy(() => import('../pages/dashboard/performance/page'));
const Profile = lazy(() => import('../pages/dashboard/profile/page'));

const routes = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:serviceId',
    element: <ServiceDetailPage />,
  },
  {
    path: '/insights',
    element: <InsightsPage />,
  },
  {
    path: '/insights/:insightId',
    element: <InsightDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/purchase/:serviceId',
    element: <PurchasePage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <DashboardOverview />
      },
      {
        path: 'investment-plan',
        element: <InvestmentPlan />
      },
      {
        path: 'performance',
        element: <Performance />
      },
      {
        path: 'profile',
        element: <Profile />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;